import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/deviceinspectstandard/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/deviceinspectstandard/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/deviceinspectstandard/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/deviceinspectstandard/submit', params,options)

export const update = (params, options) =>
request.post('/api/deviceinspectstandard/submit', params,options)
